module.exports = "/packs/images/products/devices/juul-device-top-half-3c1dc971388c6a9125fdf3229e2feb97.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/devices/juul-device-top-half.png
// module id = 1797
// module chunks = 0